import {Link} from "react-router";

import Button from "@/components/button/Button";
import {BillingPeriod} from "@/lib/types/billing.ts";
import {CallToActionBlock} from "@/pages/billing/subscription-summary/CallToActionBlock.tsx";

interface ChangeBillingPeriodProps {
  currentPlan: string;
}

export const ChangeToAnnually = ({currentPlan}: ChangeBillingPeriodProps) => {
  return (
    <div>
      <h3 className="my-4 fs-5">Change Billing Period</h3>
      <CallToActionBlock text="Switch your billing cycle to Annual, and save 16% on all plans">
        <Button
          as={Link}
          to="/billing/checkout"
          state={{
            billingPeriod: BillingPeriod.YEAR,
            plan: currentPlan,
            addedValues: [
              {
                limit_field: "annual_billing",
                amount: -1,
              },
            ],
          }}
        >
          Change To Annual
        </Button>
      </CallToActionBlock>
    </div>
  );
};
